import { errorLogger } from '../lib'

/**
 * Routing analytics logger (error-focused in production).
 */
export const logger = errorLogger('routing')

export type NavigationParameters = {
  to: string
  from?: string
  type?: string
  search?: string
  timestamp?: number
}

export type Navigate = {
  to: string
  from?: string
  type?: string
  search?: string
}
